import { render, staticRenderFns } from "./CriarPedidoDeCompraView.vue?vue&type=template&id=30c201bc&scoped=true"
import script from "./CriarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarPedidoDeCompraView.vue?vue&type=style&index=0&id=30c201bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c201bc",
  null
  
)

export default component.exports